module.exports = __webpack_public_path__ + "assets/img/Arty_Digital_001.01e3d40e-ps.jpg";